import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import opportunitiesReducer from './slices/opportunitySlice';
import userProfileReducer from './slices/userProfileSlice';
import onBoardingReducer from './slices/onBoardingSlice';
import allOpportunitiesSlice from './slices/allOpportunitySlice';
import samplingSliceReducer from './slices/samplingSlice';
import overviewSliceReducer from './slices/overviewSlice';
import actionTrackingSliceReducer from './slices/actionTrackingSlice';
import gridCustomizationSliceReducer from './slices/gridCustomizationSlice';
import ortphanSliceReducer from './slices/orphanSlice';
import tableauSlice from './slices/tableauSlice';
import contextSlice from './slices/contextSlice';
import landingPageSlice from './slices/landlinePageSlice';
import dataGPTSlice from './slices/dataGPTSlice';

export const store = configureStore({
  reducer: {
    opportunities: opportunitiesReducer,
    userProfile: userProfileReducer,
    allOpportunities: allOpportunitiesSlice,
    onBoarding: onBoardingReducer,
    sampling:samplingSliceReducer,
    overview:overviewSliceReducer,
    actionTracking:actionTrackingSliceReducer,
    gridCustomization:gridCustomizationSliceReducer,
    orphan:ortphanSliceReducer,
    tableau: tableauSlice,
    context: contextSlice,
    landingPage: landingPageSlice,
    dataGPT: dataGPTSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();